import '../../css/mk-brand.css';
import { ReactFloatingBalloons } from "react-floating-balloons";

import {useEffect, useState} from "react";
import SuperOgPanels from "../../constants/super-og-panels";
import SuperOgGameStates from "../../constants/super-og-game-states";
import GameClient from "../../lib/game-client";

function Panel({onChangePanel, data, loading, setLoading}) {
    useEffect(() => {}, );

    let isCompete = false;
    let balloons = false;
    let title = 'Game Error Occurred';
    let details = 'The game has encountered an error';
    let balloonText = 'Yay!';
    switch (data?.game?.state) {
        case SuperOgGameStates.champPaymentFailed:
        case SuperOgGameStates.challengerPaymentFailed:
            title = 'Payment Failed';
            details = 'An problem was encountered while trying to pay the wager. Please check that your wallet is connected and working then try again.';
            break;
        case SuperOgGameStates.open:
            title = 'Challenge successfully posted';
            details = `The challenge called ${data.game.handle} has been posted. Check the 'My Games' list to see the posting. You can also cancel this game on the 'My Games' page.`;
            balloons = true;
            break;
        case SuperOgGameStates.waitingForPayout:
        case SuperOgGameStates.completed:
            title = "Success, game in progress!"
            details = "Chefs and wagers are all in and the game is underway!";
            isCompete = true;
            break;
        case SuperOgGameStates.cancelled:
            title = "Game Cancelled";
            details = "The game has been cancelled. Any related transactions will be rolled back or refunded.";
            break;
        case SuperOgGameStates.error:
        default:
            // this will show the error.
            break;
    }

    return (
        <div id="super-og-alert" className="m-2">
            <div className="container bg-zinc-800 pt-4 px-4 md:px-32 pb-4 rounded-lg max-w-4xl">
                <div className="flex flex-row">
                    <div className="max-w-2xl mx-auto mb-10">
                        <div className="flex-row">
                            <div>
                                <div className="flex">
                                    <span className="text-5xl md:text-6xl lg:text-5xl font-bold text-brand">
                                      Super<span className="text-brand-text">OG </span>
                                    </span>
                                </div>
                                <div className="text-brand-text text-2xl text-right">
                                    mini-game
                                </div>
                                <div className="border border-brand" />
                            </div>
                        </div>
                        <div className="mt-6 text-white flex">
                            <div className="container flex flex-col">
                                <div>
                                    <span className="text-2xl pr-2">{title}</span>
                                    <p className="text-sx p-4">
                                        {details}
                                    </p>
                                </div>

                                {isCompete ? <button className="p-4 items-center font-bold rounded-lg bg-winner" onClick={()=> {
                                    onChangePanel(SuperOgPanels.ShowReel, {game: data?.game});
                                }}>Watch Now</button> : null}
                            </div>
                            <div className="flex flex-col space-y-2">
                                <button
                                    className="bg-brand rounded-lg pull-right p-4 w-40 h-20 font-extrabold"
                                    onClick={()=>{
                                        onChangePanel(SuperOgPanels.Lobby);
                                    }}>
                                    Go to Lobby
                                </button>
                            {data?.game?.state === SuperOgGameStates.open ?
                                    <button
                                        className="bg-brand rounded-lg pull-right p-4 w-40 h-20 font-extrabold"
                                        onClick={()=>{
                                            navigator.clipboard.writeText(GameClient.getChallengeLink(data?.game));
                                        }}>
                                        Copy Challenge Link
                                    </button>
                            : null}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {balloons ?
                <ReactFloatingBalloons
                    count={1}
                    loop={false}
                    msgText="Pop and win!"
                    colors={["yellow"]}
                    popVolumeLevel={0.1}
                />
            :
            null}
        </div>
    );
}

export default Panel;